import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ProductsPage from './pages/ProductsPageNew';
import LoginPage from './pages/LoginPage';
import AuthCallbackPage from './pages/AuthCallbackPage';
import ProductDetailsPage from './pages/ProductDetailsPage';
import CompetitorManagementPage from './pages/CompetitorManagementPageNew';
import DashboardPage from './pages/DashboardPageNew';
import HelpPage from './pages/HelpPageNew';
import SettingsPage from './pages/SettingsPage';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { setAuthToken, setupTokenRefresh } from './utils/auth';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import productsReducer from './store/slices/productsSlice';
import AdminLoginDialog from './components/Debug/AdminLoginDialog';
import { useAdminMode } from './hooks/useAdminMode';
import MainLayout from './components/Layout/MainLayout';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import AdminPage from './pages/AdminPage';

const store = configureStore({
  reducer: {
    products: productsReducer
  },
});

const AppContent = () => {
  const {
    showAdminDialog,
    setShowAdminDialog,
    loginAsUser
  } = useAdminMode();

  return (
    <>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />
        <Route path="/settings" element={<PrivateRoute><MainLayout><SettingsPage /></MainLayout></PrivateRoute>} />
        <Route path="/help" element={<PrivateRoute><MainLayout><HelpPage /></MainLayout></PrivateRoute>} />
        <Route path="/" element={<PrivateRoute><MainLayout><DashboardPage /></MainLayout></PrivateRoute>} />
        <Route path="/dashboard" element={<PrivateRoute><MainLayout><DashboardPage /></MainLayout></PrivateRoute>} />
        <Route path="/products" element={<PrivateRoute><MainLayout><ProductsPage /></MainLayout></PrivateRoute>} />
        <Route path="/product/:productId" element={<PrivateRoute><MainLayout><ProductDetailsPage /></MainLayout></PrivateRoute>} />
        <Route path="/competitor-management" element={<PrivateRoute><MainLayout><CompetitorManagementPage /></MainLayout></PrivateRoute>} />
        <Route path="/competitors/:productId" element={<PrivateRoute><MainLayout><CompetitorManagementPage /></MainLayout></PrivateRoute>} />
        <Route path="/admin" element={<AdminRoute><MainLayout><AdminPage /></MainLayout></AdminRoute>} />
      </Routes>

      <AdminLoginDialog 
        show={showAdminDialog}
        onClose={() => setShowAdminDialog(false)}
        onLogin={loginAsUser}
      />
    </>
  );
};

function App() {
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setAuthToken(token);
    }
    setupTokenRefresh();
  }, []);

  return (
    <Provider store={store}>
      <ThemeProvider>
        <Router>
          <AuthProvider>
            <ToastContainer
              position="top-center"
              autoClose={3000}
              rtl={true}
            />
            <AppContent />
          </AuthProvider>
        </Router>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
